import { format } from 'date-fns'

function convertTZ(date, tzString) {
  return new Date(
    (typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', {
      timeZone: tzString,
    })
  )
}

export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export const getTextTimeZone = () => {
  const offset = (new Date().getTimezoneOffset() / 60) * -1
  return offset >= 0
    ? `${getTimeZone() || ''} UTC +${offset}`
    : `${getTimeZone() || ''} UTC ${offset}`
}
export const getUtcTextTimeZone = () => {
  const offset = (new Date().getTimezoneOffset() / 60) * -1
  const timeZoneCity = getTimeZone().split('/')
  return offset >= 0
    ? `${timeZoneCity[1] || ''}, UTC +${offset}`
    : `${timeZoneCity[1] || ''}, UTC ${offset}`
}

export const convertTimeToTimeZone = (
  date,
  timeZone,
  pattern = 'MMM dd , yyyy HH:mm a'
) => {
  const zonedDate = convertTZ(date, timeZone)
  const output = format(zonedDate, pattern, { timeZone })
  return output
}
